import React from "react";
import { Flex, Text, Heading, Box, Image } from "theme-ui";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import { colors, typography } from "../../styles/theme";
import "../../utils/glassToken.css";
import { Button } from "../atoms";

const styles = {
  textContainer: {
    flexDirection: "column",
    alignItems: "center",
  },
  backgroundContainer: {
    py: ["4rem", "4rem", "4rem", "6.25rem"],
    mx: ["1.5rem", "2rem", "2rem", "11.56rem"],
    width: "100%",
    gap: ["2.25rem", "2.25rem", "1.5rem", "2.25rem"],
    zIndex: 10,
  },
  v6OuterContainerStyles: {
    position: "relative",
    overflow: "hidden",
    backgroundColor: colors.primaryMain,
    mb: ["4rem", "4rem", "7rem", "7rem"],
    zIndex: 1,
  },
  v6InnerContainerStyles: {
    mt: ["3.036rem", "3.036rem", "4rem", "2.188rem"],
    mb: ["4.563rem", "4.563rem", "5.75rem", "2.188rem"],
    mx: ["1.656rem", "1.656rem", "4.219rem", "6.313rem"],
    gap: ["2.25rem", "2.25rem", "3rem", "6.75rem"],
    flexDirection: ["column", "column", "column", "row"],
    "@media (min-width:900px) and (max-width: 1024px)": {
      flexDirection: "column",
      gap: "3rem"
    },
  },
  v6TextContainerStyles: {
    my: [0, 0, 0, "4.375rem"],
    width: ["100%", "100%", "100%", "50%"],
    flexDirection: "column",
    wordBreak: "break-word",
    maxWidth: "39.563rem",
    "@media (min-width:900px) and (max-width: 1024px)": {
      width: "100%",
      my: 0,
    },
    "@media (max-width:1024px)": {
      textAlign: "center",
      margin:"auto"
    },

  },
  v6MediaContainerStyles: {
    my: [0,0,0,"3.656rem"],
    "@media (min-width:900px) and (max-width: 1024px)": {
      my: 0,
      mt: "3.125rem",
    },
    '@media (max-width:768px)':{
      mb: 0,
    },
  },
  v7OuterContainerStyles: {
    position: "relative",
    width: ["24.75rem", "24.75rem", "28rem", "33.375rem"],
    height: ["41.875rem", "41.875rem", "46.563rem", "51.813rem"],
    pt: ["4.688rem", "4.688rem", "5.625rem", "6.344rem"],
    backgroundColor: colors.primary100,
    zIndex: 1,
  },
  v7InnerContainerStyles: {
    py: ["1.5rem", "1.5rem", "3rem", "3rem"],
    px: ["1.375rem", "1.375rem", "3rem", "3rem"],
    height: ["34.813rem", "34.813rem", "37.813rem", "46.25rem"],
    width: "100%",
    minWidth: "21.813rem",
  },
  v8ImageContainerStyles:{
    width: "100%",
    maxWidth: "37.688rem",
    mt: "2.188rem",
    alignItems: "center",
    order: [2, 2, 2, 1],
    "@media (max-width:899px)": {
      margin: "auto",
      mt: ["2.25rem", "2.25rem", "3rem"],
    },
  },
  v8TextContainerStyles:{
    order: [1, 1, 1, 2],
    justifyContent: "center",
    "@media (max-width:899px)": {
      mt: ["2.875rem", "2.875rem", "4rem"],
    },
    "@media (min-width:900px)": {
      textAlign: "left",
      my:"4.375rem",
    },
  }
};

const imgContainerStyle = {
  width: ["100%", "100%", "18.6875rem", "23.75rem"],
  height: "17.6875rem",
  borderRadius: "0.5rem",
  textAlign: "center",
  "@media(max-width: 1279px) and (min-width: 900px)": {
    width: "18.6875rem",
  },
};
const imgStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "0.5rem",
};

const glassV4Styles = {
  textContainer: {
    flexDirection: [
      "column-reverse",
      "column-reverse",
      "column-reverse",
      "row",
    ],
    alignItems: ["center"],
    p: [
      "2rem 1rem 1.5rem 1rem",
      "2rem 1rem 1.5rem 1rem",
      "2.63rem 2.5rem 2.69rem 2.5rem",
      "1rem 1.94rem",
    ],
    "@media(max-width: 1279px) and (min-width: 900px)": {
      flexDirection: "column-reverse",
      py: "2.625rem",
      px: "2.5rem",
      m: "4.31rem 2.38rem 2.72rem 2.25rem",
    },
  },
  backgroundContainer: {
    m: [
      "2.19rem 1.75rem 2.81rem 1.75rem",
      "2.19rem 1.75rem 2.81rem 1.75rem",
      "4.31rem 2.38rem 2.72rem 2.25rem",
      "2.12rem 7.19rem 6.4rem 7.25rem",
      "2.12rem 7.19rem 6.4rem 7.25rem",
    ],
    width: "100%",
    gap: ["1.5rem", "1.5rem", "1.5rem", "2.25rem"],
    zIndex: 10,
    "@media(max-width: 1279px) and (min-width: 900px)": {
      gap: "1.5rem",
    },
  },
  childContainer: {
    flexDirection: "column",
    width: "65%",
    alignItems: "flex-start",
    my: "3rem",
    "@media(max-width: 1279px)": {
      alignItems: "center",
      width: "100%",
      my: 0,
    },
  },
};

const glassV5Styles = {
  textContainer: {
    flexDirection: "row",
    alignItems: "center",
    p: [
      "2.62rem 0.99rem",
      "2.62rem 0.99rem",
      "4.75rem 4.5rem 5.62rem 6.1rem",
      "3rem 8.31rem 3rem 11.44rem",
    ],
  },
  backgroundContainer: {
    m: [
      "2.19rem 2.04rem 4.13rem 1.66rem",
      "2.66rem 3.13rem 4.73rem 2.13rem",
      "2.06rem 4.44rem 4.69rem 4.75rem",
      "2.06rem 4.44rem 4.69rem 4.75rem",
    ],
    width: "100%",
    zIndex: 10,
    justifyContent: "center",
  },
  childContainer: {
    flexDirection: ["column"],
    width: "100%",
    alignItems: "center",
    my: [0, 0, "3rem"],
  },
};

const Ellipse = ({ sx }) => {
  return <Flex sx={{ ...sx, position: "absolute" }}></Flex>;
};

const getColorScheme = (theme) => {
  return {
    backgroundColor:
      theme === "secondaryOrange"
        ? colors.secondaryOrangeMain
        : colors.secondaryBlueMain,
    ellipseColor:
      theme === "secondaryOrange"
        ? colors.primaryMain
        : colors.secondaryBlue200,
  };
};

const BodyBannerV1Background = ({ theme }) => {
  const ellipsePosition = [
    {
      left: ["-4.81rem", "-4.81rem", "-8rem", "-8rem"],
      top: ["-4.66rem", "-4.66rem", "-6.68rem", "-6.68rem"],
      width: ["11.56rem", "11.56rem", "20rem", "20rem"],
      height: ["11.56rem", "11.56rem", "20rem", "20rem"],
      borderRadius: ["11.56rem", "20rem", "20rem"],
    },
    {
      right: ["-0.63rem", "-0.63rem", "3.22rem", "3.22rem"],
      bottom: ["19.13rem", "19.13rem", "31.35rem", "31.35rem"],
      width: ["3.56rem", "3.56rem", "4.5rem", "4.5rem"],
      height: ["3.56rem", "3.56rem", "4.5rem", "4.5rem"],
      borderRadius: ["3.56rem", "3.56rem", "4.5rem", "4.5rem"],
    },
    {
      right: ["-15.5rem", "-15.5rem", "-12.40rem", "-12.40rem"],
      bottom: ["-8.63rem", "-8.63rem", "-11.19rem", "-11.19rem"],
      width: ["25.94rem", "25.94rem", "40.5rem", "40.5rem"],
      height: ["25.94rem", "25.94rem", "40.5rem", "40.5rem"],
      borderRadius: ["25.94rem", "25.94rem", "40.5rem", "40.5rem"],
    },
  ];
  return (
    <>
      {ellipsePosition.map((position, index) => (
        <Ellipse
          key={"ellipse" + index}
          sx={{
            ...position,
            opacity: 1,
            backgroundColor: colors[`${theme}500`],
          }}
        />
      ))}
    </>
  );
};

const BodyBannerV2Background = ({ colorScheme, theme }) => {
  const opacity = theme === "secondaryOrange" ? 1 : 0.2;
  const ellipsePosition = [
    {
      left: ["-3.63rem", "-3.63rem", "-5.47rem", "-5.47rem"],
      top: ["-8rem", "-8rem", "-3.97rem", "-3.97rem"],
      width: ["11.5rem", "11.5rem", "15.38rem", "15.38rem"],
      height: ["11.5rem", "11.5rem", "15.38rem", "15.38rem"],
      borderRadius: ["11.5rem", "11.5rem", "15.38rem", "15.38rem"],
    },
    {
      left: ["7.36rem", "7.36rem", "2.63rem", "2.63rem"],
      bottom: ["24.97rem", "24.97rem", "5.2rem", "5.22rem"],
      width: ["1.75rem", "1.75rem", "3rem", "3rem"],
      height: ["1.75rem", "1.75rem", "3rem", "3rem"],
      borderRadius: ["1.75rem", "1.75rem", "3rem", "3rem"],
    },
    {
      right: ["-6.03rem", "-6.03rem", "-13rem", "-13rem"],
      bottom: ["-12.5rem", "-12.5rem", "-11.19rem", "-11.19rem"],
      width: ["20.5rem", "20.5rem", "25.94rem", "25.94rem"],
      height: ["20.5rem", "20.5rem", "25.94rem", "25.94rem"],
      borderRadius: ["20.5rem", "20.5rem", "25.94rem", "25.94rem"],
    },
  ];
  return (
    <>
      {ellipsePosition.map((position, index) => (
        <Ellipse
          key={"ellipse" + index}
          sx={{
            ...position,
            opacity,
            backgroundColor: colorScheme.ellipseColor,
          }}
        />
      ))}
    </>
  );
};

const BodyBannerV3Background = ({ theme }) => {
  const opacity = theme === "primary" ? 0.2 : 1;
  const colorShade = theme === "primary" ? 200 : 500;
  const ellipsePosition = [
    {
      left: ["-3.33rem", "-3.33rem", "1.74rem", "3.38rem"],
      top: ["-3.33rem", "-3.33rem", "16.45rem", "15.31rem"],
      width: ["11.56rem", "11.56rem", "7.75rem", "7.75rem"],
      height: ["11.56rem", "11.56rem", "7.75rem", "7.75rem"],
      borderRadius: ["11.56rem", "11.56rem", "7.75rem", "7.75rem"],
      backgroundColor: colors[`${theme}${colorShade}`],
      opacity,
    },
    {
      right: ["16.06rem", "16.06rem", "2.38rem", "2.38rem"],
      bottom: ["1.59rem", "1.59rem", "13.63rem", "13.63rem"],
      width: ["2.25rem", "2.25rem", "3.13rem", "3.13rem"],
      height: ["2.25rem", "2.25rem", "3.13rem", "3.13rem"],
      borderRadius: ["2.25rem", "2.25rem", "3.13rem", "3.13rem"],
      backgroundColor: colors[`${theme}${colorShade}`],
      opacity,
    },
    {
      right: ["-8.63rem", "-8.63rem", "-13.54rem", "-5.75rem"],
      bottom: ["-9.19rem", "-9.19rem", "-16.13rem", "-16.13rem"],
      width: ["20.71rem", "20.71rem", "28.25rem", "28.25rem"],
      height: ["20.71rem", "20.71rem", "28.25rem", "28.25rem"],
      borderRadius: ["20.71rem", "20.71rem", "28.25rem", "28.25rem"],
      backgroundColor: colors[`${theme}${colorShade}`],
      opacity,
    },
  ];
  return (
    <>
      {ellipsePosition.map((position, index) => (
        <Ellipse
          key={"ellipse" + index}
          sx={{
            ...position,
            opacity: 0.2,
            backgroundColor: colors[`${theme}200`],
          }}
        />
      ))}
    </>
  );
};

const BodyBannerV4Background = ({ theme }) => {
  const ellipsePosition = [
    {
      left: ["0.37rem", "0.37rem", "0.94rem", 0],
      top: 0,
      width: ["6.75rem", "6.75rem", "9.75rem", "14rem"],
      height: ["6.75rem", "6.75rem", "9.75rem", "14rem"],
      borderRadius: ["6.75rem", "6.75rem", "9.75rem", "14rem"],
      "@media(max-width: 1279px) and (min-width: 900px)": {
        width: "9.75rem",
        height: "9.75rem",
      },
    },
    {
      left: [0, 0, 0, "1.25rem"],
      top: ["8rem", "8rem", "11rem", "15rem"],
      width: ["2.25rem", "2.25rem", "2.85rem", "3.5rem"],
      height: ["2.25rem", "2.25rem", "2.85rem", "3.5rem"],
      borderRadius: ["2.25rem", "2.25rem", "2.85rem", "3.5rem"],
      "@media(max-width: 1279px) and (min-width: 900px)": {
        left: 0,
        top: "11rem",
        width: "2.85rem",
        height: "2.85rem",
        borderRadius: "2.85rem",
      },
    },
    {
      right: 0,
      bottom: 0,
      width: ["7.75rem", "7.75rem", "11.375rem", "20.125rem"],
      height: ["7.75rem", "7.75rem", "11.375rem", "20.125rem"],
      borderRadius: ["7.75rem", "7.75rem", "11.375rem", "20.125rem"],
      "@media(max-width: 1279px) and (min-width: 900px)": {
        width: "11.375rem",
        height: "11.375rem",
        borderRadius: "11.375rem",
      },
    },
  ];
  return (
    <>
      {ellipsePosition.map((position, index) => (
        <Ellipse
          key={"ellipse" + index}
          sx={{
            ...position,
            backgroundColor: colors[theme + "Main"],
          }}
        />
      ))}
    </>
  );
};

const BodyBannerV5Background = ({ theme }) => {
  const ellipsePosition = [
    {
      left: ["0.37rem", "0.37rem", 0, "0.12rem"],
      top: ["0.81rem", "0.81rem", 0, "4.94rem"],
      width: ["7.875rem", "7.875rem", "9.125rem", "9.25rem"],
      height: ["7.875rem", "7.875rem", "9.125rem", "9.25rem"],
      borderRadius: ["7.875rem", "7.875rem", "9.125rem", "9.25rem"],
    },
    {
      right: ["0.35rem", "0.35rem", "0.13rem", 0],
      bottom: ["9.06rem", "9.06rem", "12.37rem", "16.06rem"],
      width: ["1.5rem", "1.5rem", "2.75rem", "3.375rem"],
      height: ["1.5rem", "1.5rem", "2.75rem", "3.375rem"],
      borderRadius: ["1.5rem", "1.5rem", "2.75rem", "3.375rem"],
    },
    {
      right: ["0.54rem", "0.54rem", "1.38rem", 0],
      bottom: ["1.94rem", "1.94rem", "1.38rem", "0.5rem"],
      width: ["6.625rem", "6.625rem", "12.125rem", "16.56255rem"],
      height: ["6.625rem", "6.625rem", "12.125rem", "16.5625rem"],
      borderRadius: ["6.625rem", "6.625rem", "12.125rem", "16.5625rem"],
    },
  ];
  return (
    <>
      {ellipsePosition.map((position, index) => (
        <Ellipse
          key={"ellipse" + index}
          sx={{
            ...position,
            backgroundColor: colors[theme + "Main"],
          }}
        />
      ))}
    </>
  );
};
const BodyBannerV6Background = () => {
  const ellipsePosition = [
    {
      width: ["15.438rem", "15.438rem", "15.438rem", "21.063rem"],
      height: ["15.438rem", "15.438rem", "17.302rem", "21.063rem"],
      left: ["-7.75rem", "-7.75rem", "-5rem", "-7.813rem"],
      top: ["0.181rem", "0.181rem", "-7.813rem", "-8.125rem"],
      borderRadius: "100%",
      backgroundColor: colors.primary200,
      zIndex: -1,
    },
    {
      width: ["22.678rem", "22.678rem", "22.678rem", "29.75rem"],
      height: ["22.678rem", "22.678rem", "25.418rem", "29.75rem"],
      right: ["-16rem", "-16rem", "-6rem", "-17rem"],
      top: ["-5.897rem", "-5.897rem", "-14.349rem", "-14.281rem"],
      borderRadius: "100%",
      backgroundColor: colors.primary200,
      zIndex: -1,
      "@media (min-width:900px) and (max-width: 1024px)": {
        left: "43.375rem",
        top: "-13.349rem",
      },
    },
    {
      width: ["4rem", "4rem", "5.25rem", "5.25rem"],
      height: ["4rem", "4rem", "5.25rem", "5.25rem"],
      right: ["-16rem", "-1.5rem", "1rem", "2rem"],
      top: ["18.23rem", "18.23rem", "13.5rem", "17rem"],
      borderRadius: "100%",
      backgroundColor: colors.primary200,
      zIndex: -1,
      "@media (min-width:900px) and (max-width: 1024px)": {
        left: "54.375rem",
        top: "18.349rem",
      },
    },
  ];
  return (
    <>
      {ellipsePosition.map((position, index) => (
        <Ellipse
          key={"ellipse" + index}
          sx={{
            ...position,
            opacity: 0.2,
            backgroundColor: colors.primary200,
          }}
        />
      ))}
    </>
  );
};
const BodyBannerV7Background = ({ theme }) => {
  const ellipsePosition = [
    {
      left: ["2.5rem", "2.5rem", "3.125rem", "1.875rem"],
      top: 0,
      width: ["10.688rem", "10.688rem", "12.313rem", "18.063rem"],
      height: ["10.688rem", "10.688rem", "12.313rem", "18.063rem"],
      borderRadius: "50%",
      zIndex: -1,
    },
    {
      left: ["13.125rem", "13.125rem", "15.625rem", "19.375rem"],
      top: ["0.313rem", "0.313rem", "1.688rem", "1.688rem"],
      width: ["2.188rem", "2.188rem", "2.5rem", "2.938rem"],
      height: ["2.188rem", "2.188rem", "2.5rem", "2.938rem"],
      borderRadius: "50%",
      zIndex: -1,
    },
    {
      left: ["15.625rem", "15.625rem", "16.875rem", "20rem"],
      bottom: ["0rem", "0rem", "0rem", "0.938rem"],
      width: ["4.813rem", "4.813rem", "5.063rem", "6.188rem"],
      height: ["4.813rem", "4.813rem", "5.063rem", "6.188rem"],
      borderRadius: "50%",
      zIndex: -1,
    },
  ];
  return (
    <>
      {ellipsePosition.map((position, index) => (
        <Ellipse
          key={"ellipse" + index}
          sx={{
            ...position,
            backgroundColor: colors[theme + "Main"],
          }}
        />
      ))}
    </>
  );
};

const BodyBannerV1 = ({
  children,
  theme,
  customStyles,
  title,
  subTitle,
  image,
  imageAlt,
}) => {
  return (
    <Flex
      style={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: colors[`${theme}Main`],
        ...customStyles,
      }}
    >
      <BodyBannerV1Background theme={theme} />
      <Flex
        sx={{
          ...styles.backgroundContainer,
          ...styles.textContainer,
          justifyContent: "center",
        }}
      >
        {image && <GatsbyImage image={getImage(image)} alt={imageAlt} />}
        <Flex
          sx={{
            ...styles.textContainer,
            gap: ["0.63rem", "0.63rem", "0.74rem", "0.75rem"],
            color: "white",
          }}
        >
          <Heading
            as="h2"
            sx={{
              ...typography.h2,
              textAlign: "center",
              color: `${theme === "primary" ? colors.white : colors.black}`,
            }}
          >
            {title}
          </Heading>
          <Text
            sx={{
              ...typography.textMd400,
              textAlign: "center",
              color: `${theme === "primary" ? colors.white : colors.black}`,
            }}
          >
            {subTitle}
          </Text>
        </Flex>
        {children}
      </Flex>
    </Flex>
  );
};
const BodyBannerV2 = ({ children, theme, customStyles, title, subTitle }) => {
  const colorScheme = getColorScheme(theme);
  return (
    <Flex
      style={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: colorScheme.backgroundColor,
        borderRadius: "1.5rem",
        ...customStyles,
      }}
    >
      <BodyBannerV2Background theme={theme} colorScheme={colorScheme} />
      <Flex
        sx={{
          ...styles.backgroundContainer,
          ...styles.textContainer,
        }}
      >
        <Flex
          sx={{
            ...styles.textContainer,
            gap: subTitle ? ["0.63rem", "0.63rem", "0.74rem", "0.75rem"] : 0,
            color: "white",
          }}
        >
          <Heading
            as="h1"
            sx={{
              ...typography.h1,
              textAlign: "center",
              color: `${theme === "primary" ? colors.white : colors.black}`,
            }}
          >
            {title}
          </Heading>
          <Text
            sx={{
              ...typography.textMd400,
              textAlign: "center",
              color: `${theme === "primary" ? colors.white : colors.black}`,
            }}
          >
            {subTitle}
          </Text>
        </Flex>
        {children}
      </Flex>
    </Flex>
  );
};

const BodyBannerV3 = ({
  children,
  theme,
  customStyles,
  title,
  subTitle,
  imageUrl,
  imageAlt,
}) => {
  return (
    <Flex
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundColor:
          theme === "primary" ? colors.primaryMain : colors.secondaryBlueMain,
        borderRadius: "1.5rem",
        ...customStyles,
      }}
    >
      <BodyBannerV3Background theme={theme} />
      <Flex
        sx={{
          ...styles.backgroundContainer,
          ...styles.textContainer,
          gap: ["3rem", "3rem", "1.5rem", "1.5rem"],
        }}
      >
        <Flex
          sx={{
            ...styles.textContainer,
          }}
        >
          {imageUrl && (
            <img
              src={imageUrl}
              alt={imageAlt}
              style={{
                width: "11.23719rem",
                height: "2.69075rem",
                marginBottom: "1.5rem",
              }}
            />
          )}
          <Heading
            as="h2"
            sx={{
              ...typography.h2,
              textAlign: "center",
              color: theme === "primary" ? colors.white : colors.black,
            }}
          >
            {title}
          </Heading>
          {subTitle && (
            <Text
              sx={{
                ...typography.textMd400,
                textAlign: "center",
                color: theme === "primary" ? colors.white : colors.black,
                mt: ["1.5rem", "1.5rem", "0.625rem", "0.625rem"],
              }}
            >
              {subTitle}
            </Text>
          )}
        </Flex>
        {children}
      </Flex>
    </Flex>
  );
};

const BodyBannerV4 = ({
  children,
  theme,
  customStyles,
  title,
  subTitle,
  image,
  imageUrl,
  imageAlt,
}) => {
  return (
    <Flex
      style={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: colors.white,
        ...customStyles,
      }}
    >
      <BodyBannerV4Background theme={theme} />
      <Flex
        sx={{
          ...glassV4Styles.backgroundContainer,
          ...glassV4Styles.textContainer,
          borderRadius: "1rem",
          border: `1.14px solid ${colors.neutral200}`,
        }}
        className="glass300"
      >
        <Box sx={imgContainerStyle}>
          {image && (
            <GatsbyImage
              image={getImage(image)}
              alt={imageAlt ?? title}
              className="banner-v4-image"
            />
          )}
          {imageUrl && <img src={imageUrl} alt={imageAlt} style={imgStyle} />}
        </Box>

        <Flex
          sx={{
            ...glassV4Styles.childContainer,
          }}
        >
          <Heading
            as="h1"
            sx={{
              ...typography.h1,
              textAlign: "left",
              color: colors.black,
              "@media(max-width: 1279px)": {
                textAlign: "center",
              },
            }}
          >
            {title}
          </Heading>
          <Text
            sx={{
              ...typography.textMd400,
              textAlign: "left",
              color: colors.neutral800,
              mt: subTitle ? "0.25rem" : 0,
              mb: "2rem",
              "@media(max-width: 1279px)": {
                textAlign: "center",
              },
            }}
          >
            {subTitle}
          </Text>
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};

const BodyBannerV5 = ({
  children,
  theme,
  customStyles,
  title,
  subTitle,
  elementCustomStyles,
}) => {
  return (
    <Flex
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: colors.white,
        ...customStyles,
      }}
    >
      <BodyBannerV5Background theme={theme} />
      <Flex
        sx={{
          ...glassV5Styles.backgroundContainer,
          ...glassV5Styles.textContainer,
          borderRadius: "1rem",
          border: `1.14px solid ${colors.neutral200}`,
          ...elementCustomStyles,
        }}
        className="glass300"
      >
        <Flex
          sx={{
            ...glassV5Styles.childContainer,
            color: "white",
          }}
        >
          {title && (
            <Heading
              as="h1"
              sx={{
                ...typography.h1,
                textAlign: "center",
                color: colors.black,
              }}
            >
              {title}
            </Heading>
          )}
          {subTitle && (
            <Text
              sx={{
                ...typography.textMd400,
                textAlign: "center",
                color: colors.neutral800,
                mt: subTitle ? "0.25rem" : 0,
                mb: children ? "2rem" : 0,
              }}
            >
              {subTitle}
            </Text>
          )}
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};

const BodyBannerV6 = ({
  children,
  theme,
  customStyles,
  title,
  desc,
  primaryBtnLabel,
  primaryBtnId="action_banner_btn",
  onPrimaryButtonClick,
  secondaryBtnLabel,
  secondaryBtnId="action_banner_secondary_btn",
  onSecondaryButtonClick,
  testimonial,
}) => {
  return (
    <Box
      sx={{
        ...styles.v6OuterContainerStyles,
        ...customStyles,
      }}
    >
      <BodyBannerV6Background theme={theme} />
      <Flex sx={styles.v6InnerContainerStyles}>
        <Box
          sx={{
            ...styles.v6MediaContainerStyles,
            mt: [
              testimonial ? "3.125rem" : 0,
              testimonial ? "3.125rem" : 0,
              testimonial ? "3.125rem" : 0,
              "3.656rem",
            ],
          }}
        >
          {children}
        </Box>
        <Flex sx={styles.v6TextContainerStyles}>
          {title && (
            <Text
              as="h2"
              sx={{ ...typography.h2, color: colors.white, mb: "1.5rem" }}
            >
              {title}
            </Text>
          )}
          {desc && (
            <Text
              sx={{
                ...typography.textMd400,
                color: colors.white,
                mb: ["2rem", "2rem", "3rem", "3rem"],
              }}
            >
              {desc}
            </Text>
          )}
          {(primaryBtnLabel || secondaryBtnLabel) && (
            <Flex
              sx={{
                gap: "1rem",
                "@media (max-width:1024px)": {
                  justifyContent: "center",
                },
              }}
            >
              {primaryBtnLabel && (
                <Button variant="filled" id={primaryBtnId} onClick={onPrimaryButtonClick}>
                  {primaryBtnLabel}
                </Button>
              )}
              {secondaryBtnLabel && (
                <Button variant="outlined" id={secondaryBtnId} onClick={onSecondaryButtonClick}>
                  {secondaryBtnLabel}
                </Button>
              )}
            </Flex>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

const BodyBannerV7 = ({
  children,
  theme,
  customStyles,
  innerContainerCustomStyles,
}) => {
  return (
    <Box
      sx={{...styles.v7OuterContainerStyles, ...customStyles}}
    >
      <BodyBannerV7Background theme={theme} />
      <Box
        sx={{...styles.v7InnerContainerStyles, ...innerContainerCustomStyles}}
        className="glass300"
      >
        {children}
      </Box>
    </Box>
  );
};
const BodyBannerV8 = ({
  theme,
  customStyles,
  imageUrl,
  image,
  imageAlt,
  title,
  desc,
  primaryBtnLabel,
  primaryBtnId="action_banner_btn",
  onPrimaryButtonClick,
  secondaryBtnLabel,
  secondaryBtnId="action_banner_secondary_btn",
  onSecondaryButtonClick,
}) => {
  return (
    <Box
      sx={{
        ...styles.v6OuterContainerStyles,
        ...customStyles,
      }}
    >
      <BodyBannerV6Background theme={theme} />
      <Flex
        sx={{
          flexDirection: ["column", "column", "column", "row"],
          px: ["1rem", "1rem", "4.219rem", "6.313rem"],
          justifyContent: "center",
          gap: [0, 0, 0, "6.75rem"],
        }}
      >
        <Flex sx={styles.v8ImageContainerStyles}>
          {image && <GatsbyImage image={getImage(image)} alt={imageAlt} />}
          {imageUrl && <Image src={imageUrl} alt={imageAlt} />}
        </Flex>
        <Flex
          sx={{
            ...styles.v6TextContainerStyles,
            ...styles.v8TextContainerStyles,
          }}
        >
          {title && (
            <Text
              as="h2"
              sx={{ ...typography.h2, color: colors.white }}
            >
              {title}
            </Text>
          )}
          {desc && (
            <Text
              sx={{
                ...typography.textLg400,
                color: colors.white,
                mt: "1.5rem"
              }}
            >
              {desc}
            </Text>
          )}
          {(primaryBtnLabel || secondaryBtnLabel) && (
            <Flex
              sx={{
                gap: "1rem",
                mt: ["2rem", "2rem", "3rem", "3rem"],
                "@media (max-width:899px)": {
                  justifyContent: "center",
                },
              }}
            >
              {primaryBtnLabel && (
                <Button
                  variant="filled"
                  id={primaryBtnId}
                  onClick={onPrimaryButtonClick}
                >
                  {primaryBtnLabel}
                </Button>
              )}
              {secondaryBtnLabel && (
                <Button
                  variant="outlined"
                  id={secondaryBtnId}
                  onClick={onSecondaryButtonClick}
                >
                  {secondaryBtnLabel}
                </Button>
              )}
            </Flex>
          )}
        </Flex>
      </Flex>
    </Box>
  );
}

const ActionBanner = (props) => {
  const { variant } = props;
  return (
    <>
      {variant === "BodyBannerV1" && <BodyBannerV1 {...props} />}
      {variant === "BodyBannerV2" && <BodyBannerV2 {...props} />}
      {variant === "BodyBannerV3" && <BodyBannerV3 {...props} />}
      {variant === "BodyBannerV4" && <BodyBannerV4 {...props} />}
      {variant === "BodyBannerV5" && <BodyBannerV5 {...props} />}
      {variant === "BodyBannerV6" && <BodyBannerV6 {...props} />}
      {variant === "BodyBannerV7" && <BodyBannerV7 {...props} />}
      {variant === "BodyBannerV8" && <BodyBannerV8 {...props} />}
    </>
  );
};

ActionBanner.propTypes = {
  theme: PropTypes.string,
  customStyles: PropTypes.object,
  innerContainerCustomStyles: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subTitle: PropTypes.string.isRequired,
  image: PropTypes.object,
  variant: PropTypes.string,
  imageAlt: PropTypes.string,
  imageUrl: PropTypes.string,
  desc: PropTypes.string,
  primaryBtnLabel: PropTypes.string,
  primaryBtnId: PropTypes.string,
  secondaryBtnLabel: PropTypes.string,
  secondaryBtnId: PropTypes.string,
  videoUrl: PropTypes.string
};

ActionBanner.defaultProps = {
  theme: "primary",
  customStyles: {},
  subTitle: "",
  variant: "BodyBannerV2",
  imageUrl: "",
  imageAltText: "",
  videoUrl: "",
};

export default ActionBanner;
